window['contact_types#index'] = function () {
  $('#new-value').on('click', function () {
    $('#new_contact_type_form').slideDown()
  })
}
